import { Formatters, Messages } from '../../codegen/Localize';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { getSetFlowParametersDialog } from '../components/SetFlowParametersDialog';
import { FlowBasicInfo } from '../models/FlowInfo';
import { Flows } from '../resources/Flows';
import { RunFlowOnOutputStepsNotification } from '../services/RunFlowOnOutputStepsNotification';
import { FlowParameterParams } from '../types/FlowParameters';
import { areFlowParametersEnabled } from '../utils/FlowParametersUtils';

export namespace RunFlowOnOutputStepsAction {
  export function dialog(
    flow: FlowBasicInfo,
    outputIds: string[],
    isIncremental: boolean,
  ): Promise<any> {
    const dialogBody = Messages.runFlowsOnOutputStepsPrompt({
      ITEM_COUNT: outputIds.length,
      ITEM_COUNT_LOC: Formatters.formatCount(outputIds.length)
    });

    const callback = (parameterList: FlowParameterParams[]) => (map: {[key: string]: string}): Promise<any> => {
      Object.keys(map).forEach(key => {
        parameterList.push({
          id: key,
          overrideValue: map[key],
        });
      });
      return Promise.resolve();
    };

    const action = () => {
      if (areFlowParametersEnabled()) {
        const parameterParams: FlowParameterParams[] = [];
        // Get full flow info for parameters 
        return Flows.getById(flow.id).then(result => {
          if (result.relevantParameters.length === 0) {
            return Promise.resolve({});
          }
          return getSetFlowParametersDialog(
            result.name,
            result.relevantParameters,
            callback(parameterParams)
          );
        }).then(() => {
          return Flows.runFlowOnOutputSteps(flow.id, outputIds, isIncremental, parameterParams);
        });
      } else {
        return Flows.runFlowOnOutputSteps(flow.id, outputIds, isIncremental);
      }
    };

    const dialogInstance = openReactConfirmationDialog<void, IResult>({
      title: Messages.runNow(),
      message: dialogBody,
      dialogWidth: TabDialogWidth.width375px,
      paramsForAction: undefined,
      actionName: Messages.runNowConfirmButton(),
      action: action,
    });

    dialogInstance.result.then((result: IResult) => {
      RunFlowOnOutputStepsNotification.notify(result, flow, outputIds.length);
    });

    return Promise.resolve(dialogInstance.result);
  }
}
